import React from 'react';
import { AlertCircleIcon, XCircleIcon, CreditCardIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* Opening Hook */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-373">
        <div className="max-w-4xl mx-auto px-6" data-id="element-374">
          <p className="text-xl md:text-2xl text-gray-700 text-center leading-relaxed mb-8" data-id="element-375">
            <span className="font-semibold text-gray-900" data-id="element-376">
              Si hasta ahora Meta Ads te da curiosidad… pero también un poco de
              pánico,
            </span>{' '}
            esta página es para ti.
          </p>

          <div className="bg-gray-50 rounded-2xl p-8 md:p-10 mb-12" data-id="element-377">
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-378">
              Tal vez te pasa algo de esto:
            </p>
            <ul className="space-y-4 text-gray-700" data-id="element-379">
              <li className="flex items-start gap-3" data-id="element-380">
                <span className="text-[#0866FF] mt-1" data-id="element-381">•</span>
                Has escuchado que "Meta Ads es clave para vender", pero no sabes
                ni por dónde empezar.
              </li>
              <li className="flex items-start gap-3" data-id="element-382">
                <span className="text-[#0866FF] mt-1" data-id="element-383">•</span>
                Abriste el Administrador de Anuncios una vez… viste columnas,
                botones y nombres raros… y lo cerraste.
              </li>
              <li className="flex items-start gap-3" data-id="element-384">
                <span className="text-[#0866FF] mt-1" data-id="element-385">•</span>
                Te da miedo meter la tarjeta, tocar algo mal y perder dinero sin
                entender qué pasó.
              </li>
              <li className="flex items-start gap-3" data-id="element-386">
                <span className="text-[#0866FF] mt-1" data-id="element-387">•</span>
                Te encantaría poder decir: "Yo mismo sé crear mis campañas",
                pero sientes que "no eres técnico".
              </li>
            </ul>
          </div>

          <p className="text-xl text-center text-gray-700 mb-6" data-id="element-388">
            Si asientes con la cabeza… sigue leyendo.
          </p>

          <div className="bg-[#0866FF] text-white rounded-2xl p-8 md:p-10 text-center" data-id="element-389">
            <p className="text-2xl md:text-3xl font-bold mb-4" data-id="element-390">
              No necesitas ser "experto en marketing" para usar Meta Ads.
            </p>
            <p className="text-xl" data-id="element-391">
              Solo necesitas que alguien te lleve de la mano, en vivo, desde
              cero.
            </p>
          </div>
        </div>
      </section>

      {/* The Real Problem */}
      <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-392">
        <div className="max-w-4xl mx-auto px-6" data-id="element-393">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-394">
            El problema no es Meta Ads.
          </h2>
          <p className="text-xl text-center text-gray-600 mb-12" data-id="element-395">
            El problema es cómo te lo han explicado hasta ahora.
          </p>

          <div className="bg-white rounded-2xl p-8 md:p-10 mb-8" data-id="element-396">
            <p className="text-lg text-gray-700 mb-6" data-id="element-397">
              Si eres principiante, lo más probable es que hayas vivido algo
              así:
            </p>

            <div className="space-y-6" data-id="element-398">
              <div className="flex gap-4 items-start p-6 bg-gray-50 rounded-xl" data-id="element-399">
                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-400">
                  <AlertCircleIcon className="w-5 h-5 text-red-600" data-id="element-401" />
                </div>
                <div data-id="element-402">
                  <p className="text-gray-700 mb-2" data-id="element-403">
                    Buscaste "cómo hacer anuncios en Facebook" en YouTube.
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-404">
                    Viste videos llenos de nombres raros, cambios de pantalla
                    rapidísimos y un montón de pestañas abiertas.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start p-6 bg-gray-50 rounded-xl" data-id="element-405">
                <div className="flex-shrink-0 w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-406">
                  <XCircleIcon className="w-5 h-5 text-orange-600" data-id="element-407" />
                </div>
                <div data-id="element-408">
                  <p className="text-gray-700 mb-2" data-id="element-409">
                    Te guardaste algunos reels, pero cuando los quisiste
                    aplicar…
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-410">
                    Tu pantalla no se parecía a la del video.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start p-6 bg-red-50 rounded-xl border border-red-200" data-id="element-411">
                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-412">
                  <BrainIcon className="w-5 h-5 text-red-600" data-id="element-413" />
                </div>
                <div data-id="element-414">
                  <p className="text-lg font-semibold text-gray-900 mb-2" data-id="element-415">
                    Resultado:
                  </p>
                  <p className="text-gray-700" data-id="element-416">
                    Confusión total → Miedo → "Mejor lo dejo para después".
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-10" data-id="element-417">
            <p className="text-lg text-gray-700 mb-6" data-id="element-418">
              O quizás pensaste en contratar una agencia/freelancer desde el
              inicio, pero te da miedo:
            </p>
            <ul className="space-y-3 text-gray-700 mb-8" data-id="element-419">
              <li className="flex items-center gap-3" data-id="element-420">
                <CreditCardIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-421" />
                Pagar sin entender nada.
              </li>
              <li className="flex items-center gap-3" data-id="element-422">
                <AlertCircleIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-423" />
                Volverte dependiente de alguien para algo tan importante como
                tus clientes.
              </li>
            </ul>

            <div className="bg-gray-900 text-white rounded-xl p-6" data-id="element-424">
              <p className="text-xl font-semibold mb-3" data-id="element-425">La realidad es esta:</p>
              <p className="text-lg text-gray-300" data-id="element-426">
                No es que "no sirvas" para lo técnico.{' '}
                <span className="text-white font-semibold" data-id="element-427">
                  Te están hablando en un idioma que todavía no conoces.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What You Need */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-428">
        <div className="max-w-4xl mx-auto px-6" data-id="element-429">
          <p className="text-xl text-gray-700 mb-6" data-id="element-430">
            Lo que necesitas no es más teoría suelta. Lo que necesitas es un
            curso donde:
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-431">
            <div className="bg-green-50 border border-green-200 rounded-xl p-6" data-id="element-432">
              <p className="text-gray-700 flex items-center gap-3" data-id="element-433">
                <span className="text-green-600 font-bold text-xl" data-id="element-434">✓</span>
                Empieces desde cero-cero.
              </p>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-xl p-6" data-id="element-435">
              <p className="text-gray-700 flex items-center gap-3" data-id="element-436">
                <span className="text-green-600 font-bold text-xl" data-id="element-437">✓</span>
                Te expliquen con ejemplos cercanos.
              </p>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-xl p-6" data-id="element-438">
              <p className="text-gray-700 flex items-center gap-3" data-id="element-439">
                <span className="text-green-600 font-bold text-xl" data-id="element-440">✓</span>
                Veas en vivo cómo se arma una campaña.
              </p>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-xl p-6" data-id="element-441">
              <p className="text-gray-700 flex items-center gap-3" data-id="element-442">
                <span className="text-green-600 font-bold text-xl" data-id="element-443">✓</span>
                Tenga espacio para preguntar tus dudas sin sentirte "tonto".
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-444">
            <p className="text-2xl font-bold text-[#0866FF]" data-id="element-445">
              Eso es exactamente lo que vas a encontrar en META ADS DESDE CERO.
            </p>
          </div>
        </div>
      </section>
    </>;
}